import type { ISocial } from "../../../../types/models/social.models.types";

import { usePostHttp } from "../../http.hook";

interface IBody {
  platform: string;
  handle: string;
}

interface IResponse {
  social: ISocial;
}

export function useAddSocialAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/socials",
  });
}
